import { createReducer, on } from "@ngrx/store";
import { addCatalogProduct, loadOrganizationCatalog, loadOrganizationCatalogByID, loadOrganizationCatalogFailed, loadOrganizationCatalogSuccess, loadOrganizationCatalogTemplates, loadOrganizationCatalogTemplatesFailed, loadOrganizationCatalogTemplatesSuccess, removeCatalogProduct, removeCatalogProductsById, resetOrganizationCatalogTemplates, updateCatalogProductAudience } from "../actions/organization-catalog.actions";
import { organizationCatalogInitialState } from "../initial-states/organization-catalog.state";
import { OrganizationCatalogStatus, ProductAudience } from "src/app/models/organization-catalog.model";
import { UserProduct } from "src/app/models/user-products.model";

export const OrganizationCatalogReducer = createReducer(organizationCatalogInitialState,

	// The reducer runs when a dispatch 'loadOrganizationCatalog' was triggered
	// The only thing we need to do here is to set the loading to true
	on(loadOrganizationCatalog,
		(state) => ({
			...state,
			info: { ...state.info, loading: true }
		})
	),
	// The reducer runs when a dispatch 'loadOrganizationCatalogByID' was triggered
	// The only thing we need to do here is to set the loading to true
	on(loadOrganizationCatalogByID,
		(state) => ({
			...state,
			info: { ...state.info, loading: true }
		})
	),

	// The reducer runs when a dispatch 'loadOrganizationCatalogSuccess' was triggered
	// Here we need to set the loading to false, set the value of 'loadedOnce' and add the value of the catalog for the specific type
	on(loadOrganizationCatalogSuccess,
		(state, { organizationCatalog }) => ({
			...state,
			info: { ...state.info, loading: false, loadedOnce: true, value: organizationCatalog, error: undefined }
		})
	),

	// The reducer runs when a dispatch 'loadOrganizationCatalogFailed' was triggered
	// Here we need to set the state to the initial one, set the value of 'loadedOnce' and add the value of the error action result into the store
	on(loadOrganizationCatalogFailed,
		(state, { error }) => ({
			...state,
			info: { ...state.info, loading: false, loadedOnce: false, value: undefined, error: error }
		})
	),

	// The reducer runs when a dispatch 'loadOrganizationCatalogTemplates' was triggered
	// The only thing we need to do here is to set the loading to true
	on(loadOrganizationCatalogTemplates,
		(state) => ({
			...state,
			templates: { ...state.templates, loading: true }
		})
	),

	// The reducer runs when a dispatch 'loadOrganizationCatalogTemplatesSuccess' was triggered
	// Here we need to set the loading to false, set the value of 'loadedOnce' and add the value of the catalog for the specific type
	on(loadOrganizationCatalogTemplatesSuccess,
		(state, { templates }) => ({
			...state,
			templates: { ...state.templates, loading: false, loadedOnce: true, value: templates }
		})
	),

	// The reducer runs when a dispatch 'loadOrganizationCatalogTemplatesFailed' was triggered
	// Here we need to set the state to the initial one, set the value of 'loadedOnce' and add the value of the error action result into the store
	on(loadOrganizationCatalogTemplatesFailed,
		(state, { error }) => ({
			...state,
			templates: { ...state.templates, loading: false, loadedOnce: false, error, value: [] }
		})
	),

	// The reducer runs when a dispatch 'resetOrganizationCatalogTemplates' was triggered
	// Here we reset the values for the templates section of store
	on(resetOrganizationCatalogTemplates,
		(state) => ({
			...state,
			templates: { loadedOnce: false, loading: false, value: [], error: undefined }
		})
	),

	// The reducer runs when a dispatch 'updateCatalogProductStatus' was triggered
	// Here we need to update the value the status
	on(removeCatalogProduct,
		(state, { templates }) => ({
			...state,
			templates: { ...state.templates, value: state.templates.loadedOnce ? removeProducts(state.templates.value, templates.map(t => t.id)) : [] }
		})
	),

	// The reducer runs when a dispatch 'removeCatalogProductsById' was triggered
	// Here we need to update the value the status
	on(removeCatalogProductsById,
		(state, { templatesId }) => ({
			...state,
			templates: { ...state.templates, value: state.templates.value.filter(x => !templatesId.includes(x.id)) }
		})
	),
	// The reducer runs when a dispatch 'updateCatalogProductStatus' was triggered
	// Here we need to update the value the status
	on(addCatalogProduct,
		(state, { templates }) => ({
			...state,
			templates: { ...state.templates, value: state.templates.loadedOnce ? addProducts(state.templates.value, templates) : [] }
		})
	),
	
	// The reducer runs when a dispatch 'updateCatalogProductStatus' was triggered
	// Here we need to update the value the status
	on(updateCatalogProductAudience,
		(state, { audience }) => ({
			...state,
			templates: { ...state.templates, value: state.templates.loadedOnce ? updateProductAudience(audience, state.templates.value) : [] }
		})
	),
)

function addProducts(currentCatalogProducts: UserProduct[], templates: UserProduct[]): UserProduct[] {

	templates.forEach(t => {
		const catalogProductToUpdateIndex = currentCatalogProducts.findIndex(x => x.id === t.id);
		if (catalogProductToUpdateIndex !== -1) {
			currentCatalogProducts[catalogProductToUpdateIndex].status = OrganizationCatalogStatus.Enabled.toString();
		}else {
			currentCatalogProducts.push(t);
		}
	});

	return currentCatalogProducts;
}

function removeProducts(currentCatalogProducts: UserProduct[], templates: string[]): UserProduct[] {

	templates.forEach(t => {
		currentCatalogProducts = currentCatalogProducts.filter(x => x.id !== t);
	});

	return currentCatalogProducts;
}

function updateProductAudience(audience: ProductAudience[], currentCatalogProducts: UserProduct[]){
	if (audience != undefined){
		audience.forEach(element => {
			const productToUpdateIndex = currentCatalogProducts.findIndex(x => x.id === element.id);
			if (productToUpdateIndex != -1) {
				currentCatalogProducts[productToUpdateIndex].audience = element.audience;
			}
		});
	}
	return currentCatalogProducts;
}


